import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  postCall,
  deleteCall,
  getById,
  BASE_URL,
  getCall,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";
import {id} from "date-fns/locale";

const initialState = {
  data: [],
  heroBannerDetail: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getHeroBanner = createAsyncThunk(
  "heroBanner/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/hero-banners?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getHeroBannerById = createAsyncThunk(
  "heroBanner/getById",
  async (id) => {
    try {
      const response = await getById(`/admin/v1/hero-banners`, id, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const addHeroBanner = createAsyncThunk(
  "heroBanner/add",
  async (data) => {
    try {
      return await postCall("/admin/v1/hero-banners", data);
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const updateBanner = createAsyncThunk(
  "heroBanner/update",
  async ({ id, formData }) => {
    try {
      return await postCall(`/admin/v1/hero-banners/${id}`, formData, true);
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const deleteHeroBanner = createAsyncThunk(
  "heroBanner/delete",
  async (id) => {
    try {
      const response = await deleteCall(`/admin/v1/hero-banners/${id}`);
      return {...response, id};
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const dragDropHeroBanner = createAsyncThunk(
  "heroBanner/dragDrop",
  async ({ id, to }) => {
    try {
      const response = await postCall(
        `/admin/v1/hero-banners/${id}/direction`,
        { to }
      );
      return response;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to reorder");
      return Promise.reject(error);
    }
  }
);

const HeroBannerSlice = createSlice({
  name: "heroBanner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHeroBanner.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHeroBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getHeroBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getHeroBannerById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHeroBannerById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getHeroBannerById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.heroBannerDetail = action.payload;
      })
      .addCase(addHeroBanner.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addHeroBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.hero_banners.push(action.payload.data);
      })
      .addCase(addHeroBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateBanner.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateBanner.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        state.data.data.hero_banners = state.data.data.hero_banners.map(item =>
            item.id === action.payload.data.id ? action.payload.data : item
        );
      })
      .addCase(updateBanner.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(deleteHeroBanner.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deleteHeroBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.hero_banners = state.data.data.hero_banners.filter(item =>
            item.id !== action.payload.id
        );
      })
      .addCase(deleteHeroBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(dragDropHeroBanner.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(dragDropHeroBanner.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(dragDropHeroBanner.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Failed to reorder item";
      });
  },
});

export default HeroBannerSlice.reducer;
